export function isNode(node) {
    if (!node) {
        return false;
    }
    return node.name !== undefined;
}
